import React, { Component } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'

import { AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import logo from '../../assets/img/brand/logo.png'

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {
  render() {
    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: logo, height: 25, alt: 'Xelacore PLM Backoffice' }}
        />
         <AppSidebarToggler className="d-md-down-none" display="lg" />
        <Nav className="d-md-down-none" navbar>
          <NavItem  className="px-3">
            <NavLink tag={Link} to="/">Dashboard</NavLink> 
          </NavItem>
          <NavItem className="px-3">   
             <NavLink tag={Link} to="/customers">Customers</NavLink>   
          </NavItem>
          <NavItem className="px-3">
            <NavLink tag={Link} to="/logout">Logout</NavLink>
          </NavItem>
        </Nav>
        <Nav className="ml-auto" navbar>
          
        </Nav>
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.js